import React, { useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import '../assets/styles/searchbox.css';
import SearchBox from '../components/searchBox';
import SearchButton from '../components/SearchButton';
import { setSearchKeyword, clearFilters } from '../redux/slices/searchSlice';
import { resetUser } from '../redux/slices/userSlice';
import { useNavigate } from 'react-router-dom';
import SEOHelper from '../helpers/seo-helper';
import { HeroImage } from '../components/common/OptimizedImage';

function HomePage() {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const categories = useSelector((state) => state.search.searchResult?.categories || []);
  const currentLang = useSelector((state) => state.language.lang);

  useEffect(() => {
    dispatch(resetUser());
    dispatch(setSearchKeyword(''));
    dispatch(clearFilters());

    // Update SEO for homepage
    const seoData = SEOHelper.generateHomepageSEO(currentLang);
    SEOHelper.updatePageSEO(seoData);
  }, [dispatch, currentLang]);

  return (
    <>
      <Container
        sx={{
          minHeight: 'calc(100vh - 64px - 64px)', // 64px footer yüksekliği için
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 10, // Footer için alt boşluk
        }}
      >
        <Box className="container">
          <Box className="spacing-large"></Box>
          <Typography variant="h2" className="heading">
            {translate('homepage.first-header')}
          </Typography>

          <Box className="spacing-small"></Box>

          <Typography variant="h5" className="subheading">
            {translate('homepage.second-header')}
          </Typography>

          <Box className="spacing-large"></Box>

          <SearchBox />

          <Box sx={{ mt: 3 }}>
            <SearchButton />
          </Box>
        </Box>
      </Container>
    </>
  );
}

export default HomePage;
